import { useEffect } from "react";
import { isAdMobAvailable, removeMainShellBanner, showMainShellBanner } from "@/lib/admob";

/**
 * ネイティブ（Capacitor）のときだけ AdMob バナーを表示。Web では何もしない。
 */
export default function AdMobBannerHost() {
  useEffect(() => {
    if (!isAdMobAvailable()) return;
    void showMainShellBanner();
    return () => {
      void removeMainShellBanner();
    };
  }, []);

  return null;
}
